import { For } from "solid-js";
import { useI18n } from "@/api/i18n";
import {
  COLOR_TRANSITION,
  FOCUS_RING,
} from "@/domains/freelance/taxonomy/components/sector-selector/primitives";
import { subcategoryLabel } from "@/domains/freelance/taxonomy/store/taxonomy-store";
import { cn } from "@/libs/cn";

const I18N = "company.search.freelancers.result.filters.job_subcategory";

export type SubcategoryChipsProps = {
  subcategories: string[];
  onRemove: (key: string, index: number) => void;
  ref?: (el: HTMLUListElement) => void;
};

/** The chosen subcategories as chips, each with a button that removes it. */
export const SubcategoryChips = (props: SubcategoryChipsProps) => {
  const { t } = useI18n();

  return (
    <ul
      ref={props.ref}
      class="mt-1 flex flex-wrap gap-1.5"
      aria-label={t(`${I18N}.chips_label`)}
    >
      <For each={props.subcategories}>
        {(key, index) => {
          const name = () =>
            t(`${I18N}.remove_chip`, {
              subcategory: subcategoryLabel(key),
            });
          return (
            <li class="inline-flex items-center rounded-full border border-primary bg-primary/5 pl-2.5 text-xs font-medium text-foreground">
              {subcategoryLabel(key)}
              <button
                type="button"
                aria-label={name()}
                title={name()}
                onClick={() => props.onRemove(key, index())}
                class={cn(
                  "flex size-6 items-center justify-center rounded-full text-foreground/70 hover:bg-foreground/5 hover:text-foreground",
                  COLOR_TRANSITION,
                  FOCUS_RING,
                )}
              >
                <i class="ph ph-x text-[11px]" aria-hidden="true" />
              </button>
            </li>
          );
        }}
      </For>
    </ul>
  );
};
